import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { HStack } from "@design-system/HStack/HStack";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    type AppliedTemplateLabel,
    type ApplyReportTemplateRow,
} from "../applyReportTemplateRows";
import { AppliedTemplateSourceTag } from "../AppliedTemplateSourceTag";

export const ApplyReportTemplateTemplateCell = memo(
    ({
        getValue,
    }: CellContext<
        ViewTableFeatures,
        ApplyReportTemplateRow,
        AppliedTemplateLabel | null
    >) => {
        const template = getValue();
        return (
            <ViewTableCell>
                {template && (
                    <HStack as="span" align="center" gap={8}>
                        <BreakableText showTooltip text={template.name} />
                        <AppliedTemplateSourceTag source={template.source} />
                    </HStack>
                )}
            </ViewTableCell>
        );
    },
);
